export default "__VITE_ASSET__BS7WMgUA__"